/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ErrorHelper(error: any): void {
  if (error?.response?.status === 401) {
    window.location.replace('https://www.peachmindfulness.com/invalid-access/')
  } else if (error?.response?.status === 404) {
    window.location.replace('https://www.peachmindfulness.com/invalid-page/')
  }
}
